import { transformGqlToAgeRestriction } from '@/scenarios/legacy-player/lib/transform-age-restriction';

import { useReadEpisodePlayerBaseInfo } from './use-read-episode-player-base-info';

export function useEpisodeAgeRestriction(contentId: string): string | undefined {
    const episode = useReadEpisodePlayerBaseInfo(contentId);

    const ageRestriction = episode?.tvSeries?.restriction?.age;

    return ageRestriction ? transformGqlToAgeRestriction(ageRestriction) : undefined;
}
